<template>
  <div id="app">
    <div
      class="background-cover"
      style="background-size: cover; transition: background-image 0.6s"
      v-lazy:background-image="info.image.url.webp_full"
    ></div>
    <div
      class="flex-center"
      style="justify-content: center; align-items: center; display: flex"
    >
      <div class="content-box card-box col-11-max">
        <div class="fancy-box">
          <h1 class="fancy-box-heading">条款及私隐政策</h1>
          <div class="content-section">
            <p>本实例的拥有者并不推荐您注册与使用本实例</p>
            <p>因为,我们并不保证：</p>
            <br />
            <ul>
              <li>本实例永远可用，用户数据永远不丢失</li>
              <li>
                您的数据存在我们这里就安全无虞，隐私数据永远不会被黑客获取
              </li>
              <li>版权拥有者永远不会向您发送律师函，索要赔款</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      info: null,
    };
  },
  created() {
    const _this = this;
    axios
      .get(
        "https://img.fudaoyuan.icu/api/1/random/?format=json&webp=true&md=false&scale_min=1.5"
      )
      .then((response) => {
        _this.info = response.data;
        Vue.use(VueLazyload);
      });
  },
};
</script>
<style>
body {
  display: flex;
  padding-top: 65px;
  padding-bottom: 20px;
  min-height: 100%;
  background: #fefefe;
  position: relative;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
}
</style>

